import { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { setMessengerTabState, setWidgetTab } from 'app/redux/widget/widget.actions'
import { setActiveDepartment } from 'app/redux/messages/messages.actions'
import { HomeIcon, HelpIcon, MessengerIcon } from 'app/components/icons'
import Home from './tabs/home'
import Messenger from './tabs/messenger'
import Help from './tabs/help'
import { MESSENGER_TAB_STATE } from 'app/constants/launcherContentStates'
import clsx from 'clsx'
import './cover.scss'
import StartChatButton from './components/StartChat'
import LinearAvatarsCollection from 'app/components/LinearAvatarsCollection'

const getLanguageInfo = ({ widgetData }) => widgetData.widgetInfo.languageInfo
const getDepartments = ({ widgetData }) => widgetData.widgetInfo.data?.teams
const getIsWidgetWideOpen = ({ widgetData }) => widgetData.widgetInfo.isWidgetWideOpen
const getCurrentTab = ({ widgetData }) => widgetData.widgetInfo.currentTab
const getMessengerTabState = ({ widgetData }) => widgetData.widgetInfo.messengerTabState
const getSelectedQuestion = ({ messagesData }) => messagesData.selectedQuestion
const getAcceptedChat = ({ messagesData }) => messagesData.acceptedChat
const getActiveDepartment = ({ messagesData }) => messagesData.activeDepartment.data
const getHeaderExpand = ({ widgetData }) => widgetData.widgetInfo.headerExpand
const getAllDepartments = ({ messagesData }) => messagesData.departments.data
const getGreetingBtnLabel = ({ widgetData }) => widgetData.widgetInfo.data.personalize.startMessagingTitle
const getOperators = ({ widgetData }) => widgetData.widgetInfo.data.operators
const getFaqs = ({ widgetData }) => widgetData.widgetInfo.data?.faq
const getWidgetInfo = ({ widgetData }) => widgetData.widgetInfo

const Cover = () => {
  const [showAvatarsCollection, setShowAvatarsCollection] = useState(false)
  const widgetInfo = useSelector(getWidgetInfo)
  const languageInfo = useSelector(getLanguageInfo)

  const departments = useSelector(getDepartments)
  const isWidgetWideOpen = useSelector(getIsWidgetWideOpen)
  const currentTab = useSelector(getCurrentTab)
  const messengerTabState = useSelector(getMessengerTabState)
  const selectedQuestion = useSelector(getSelectedQuestion)
  const acceptedChat = useSelector(getAcceptedChat)
  const activeDepartment = useSelector(getActiveDepartment)
  const headerExpand = useSelector(getHeaderExpand)
  const allDepartments = useSelector(getAllDepartments)
  const greetingBtnLabel = useSelector(getGreetingBtnLabel)
  const operators = useSelector(getOperators)
  const faqs = useSelector(getFaqs)

  const faqTabDisabled = !faqs.length || !faqs.some((item) => item.questions.length)
  const getDepartmentsNotSeenReceivedMsgsCount = () =>
    allDepartments.reduce((sum, dp) => (sum += dp.notSeenMsgsCount), 0)

  const dispatch = useDispatch()

  // const department = departments?.find((item) => item._id === activeDepartment);

  const showNavBar = !isWidgetWideOpen && (currentTab !== 1 || messengerTabState !== MESSENGER_TAB_STATE.CHAT)
  // const showAvatarsCollection = faqs.filter((item) => !item.disabled).length === 0
  const showGreetingCollection = currentTab === 0

  const handleSetCurrentTab = (tab) => {
    dispatch(setWidgetTab(tab))
  }

  const handleStartMessaging = () => {
    const departmentId = departments[0]._id
    dispatch(setActiveDepartment(departmentId))
    dispatch(setMessengerTabState(MESSENGER_TAB_STATE.CHAT))
    dispatch(setWidgetTab(1))
  }

  const handleSelectHomeTab = () => {
    handleSetCurrentTab(0)
  }

  const handleSelectMessangerTab = () => {
    handleSetCurrentTab(1)

    if (departments) {
      if (departments.length === 1) {
        const departmentId = departments[0]._id
        dispatch(setActiveDepartment(departmentId))
        dispatch(setMessengerTabState(MESSENGER_TAB_STATE.CHAT))
        return
      }
      dispatch(setMessengerTabState(MESSENGER_TAB_STATE.DEPARTMENTS))
      return
    }
    dispatch(setMessengerTabState(MESSENGER_TAB_STATE.CHAT))
  }

  const handleSelectHelpTab = () => {
    if (faqs.length) {
      handleSetCurrentTab(2)
    }
  }

  const getCoverHeaderStyle = () => {
    if (currentTab === 0) return 'cover_content_home_header'
    if (currentTab === 1) {
      if (messengerTabState === MESSENGER_TAB_STATE.CHAT) {
        // for all accepted chats
        if (acceptedChat[activeDepartment])
          return `cover_content_messenger_accepted_chat_header ${headerExpand ? '' : 'collapsed'}`
        // team chat page(not accepted)
        if (departments && departments.length > 1) return 'cover_content_messenger_team_chat_header'

        // team chat page when there is just one department(not accepted)
        if (departments) return `cover_content_messenger_chat_header ${headerExpand ? '' : 'collapsed'}`
      }

      // departments list
      if (departments && departments.length > 1) return 'cover_content_messenger_team_chat_header'
    }
    if (currentTab === 2)
      return isWidgetWideOpen && !!selectedQuestion ? 'cover_content_question_header' : 'cover_content_help_header'
  }

  const showNewMsgNotifBadge = (tabIndex) => {
    // do not show notif badge if tabIndex is not 1 that is equivalent to 'messanger' tab
    const notShowNewMsgBadgeForIrrelevantTab = tabIndex !== 1
    if (notShowNewMsgBadgeForIrrelevantTab) return

    const allNotSeenReceivedMsgsCount = getDepartmentsNotSeenReceivedMsgsCount()
    const shouldRenderNotifBadge = allNotSeenReceivedMsgsCount > 0

    return shouldRenderNotifBadge
  }

  // const swipeHandlers = useDetectSwipe({
  //   onSwipedLeft: () => {
  //     if (currentTab > 0) handleSetCurrentTab(currentTab - 1);
  //   },
  //   onSwipedRight: () => {
  //     if (currentTab < 2) handleSetCurrentTab(currentTab + 1);
  //   },
  // });

  const NAVBAR_ITEMS = [
    {
      icon: <HomeIcon color={'#000000'} />,
      text: languageInfo.texts.home,
      handler: handleSelectHomeTab,
    },
    {
      icon: <MessengerIcon color={'#000000'} />,
      text: languageInfo.texts.messenger,
      handler: handleSelectMessangerTab,
    },
    {
      icon: <HelpIcon color={'#000000'} />,
      text: languageInfo.texts.knowledgeBase,
      handler: handleSelectHelpTab,
      disabled: faqTabDisabled,
    },
  ]

  const renderAvatarsCollection = <LinearAvatarsCollection avatarSize={36} operators={operators.slice(0, 4)} />

  return (
    <div className="cover_container__wrapper">
      <div className="cover_container">
        <main
          // {...swipeHandlers}
          className="cover_content"
        >
          <div className={clsx('cover_content_header', getCoverHeaderStyle())} />

          <Home
            showGreetingAvatars={showAvatarsCollection}
            setShowGreetingAvatars={setShowAvatarsCollection}
            ct={currentTab}
          />
          <Messenger ct={currentTab} />
          <Help ct={currentTab} />
        </main>

        {/* Navigation Bar */}
        <div data-show={showNavBar} className="cover_navbar">
          {showGreetingCollection && (
            <div className="cover_navbar__greeting_collection">
              {showAvatarsCollection && !widgetInfo.data.personalize?.hideOperator && (
                <div className="cover_navbar__avatars">{renderAvatarsCollection}</div>
              )}

              <StartChatButton
                onClick={handleStartMessaging}
                className="cover_navbar__greeting"
                label={greetingBtnLabel}
              />
            </div>
          )}

          <div className="cover_navbar_items_wrapper">
            {NAVBAR_ITEMS.map((item, index) => {
              return (
                <button
                  onClick={item.handler}
                  key={item.text}
                  className="cover_navbar_item"
                  data-active={index === currentTab}
                  disabled={item.disabled}
                >
                  <div data-newmsg={showNewMsgNotifBadge(index)} className="cover_navbar_item_icon">
                    {item.icon}
                  </div>
                  <span className="cover_navbar_item_text">{item.text}</span>
                </button>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Cover
